export const ACL_MANAGE = "manage"
export const ACL_CREATE = "create"
export const ACL_READ = "read"
export const ACL_UPDATE = "update"
export const ACL_DELETE = "delete"
export const ACL_VERIFY = "verify"
export const ACL_APPROVE = "approve"

export const ACL_SUBJECT_PROFILE = "Profile"
export const ACL_SUBJECT_CATEGORY = "Category"
export const ACL_SUBJECT_USER = "User"
export const ACL_SUBJECT_ORGANIZATION = "Organization"
export const ACL_SUBJECT_PERSON = "Person"
export const ACL_SUBJECT_IDENTIFICATION = "Identification"
export const ACL_SUBJECT_SERVICE = "Service"
export const ACL_SUBJECT_INSTRUCTION = "Instruction"
